import { Box } from '@ltvco/refresh-lib/theme';
import { TypingIndicator, Message } from '@ltvco/refresh-lib/v2';

import { MessageContent } from '../PhotoDamageAnalyzer/MessageContent/MessageContent';

import { baseMessageBoxContainerStyles } from './ChatPage/components/MessagesContainer';

interface IAssistantSectionProps {
  assistant: Message | null;
  assistantIndex: number | null;
  isLastPair: boolean;
  hasUserScrolled: boolean;
  loadingStatus: { message: string; subtitle: string };
  firstAssistantIndexToSkip: number;
  onMessageRef: (index: number, element: HTMLDivElement | null) => void;
  onTypingRef: (element: HTMLDivElement | null) => void;
  onGapRef: (element: HTMLDivElement | null) => void;
  tailGap: number;
}

/**
 * AssistantSection - Renders assistant message or typing indicator
 * Skips rendering for the first result (shown as a dedicated card)
 * @component
 */
export const AssistantSection: React.FC<IAssistantSectionProps> = ({
  assistant,
  assistantIndex,
  isLastPair,
  hasUserScrolled,
  loadingStatus,
  firstAssistantIndexToSkip,
  onMessageRef,
  onTypingRef,
  onGapRef,
  tailGap,
}) => {
  if (assistantIndex !== null && assistantIndex === firstAssistantIndexToSkip) {
    return null;
  }

  if (assistant) {
    return (
      <>
        <Box
          ref={(el: HTMLDivElement | null) => {
            if (assistantIndex !== null) {
              onMessageRef(assistantIndex, el);
            }
          }}
          sx={baseMessageBoxContainerStyles}
        >
          <MessageContent
            content={assistant.content || 'Result'}
            isHeader={false}
            isSticky={false}
            hasUserScrolled={hasUserScrolled}
          />
        </Box>
        {isLastPair && tailGap > 0 && (
          <Box ref={onGapRef} sx={{ height: `${tailGap}px`, width: '100%' }} />
        )}
      </>
    );
  }

  return (
    <>
      <Box ref={onTypingRef} sx={{ width: '100%', maxWidth: '740px' }}>
        <TypingIndicator loadingStatus={loadingStatus} />
      </Box>
      {isLastPair && tailGap > 0 && (
        <Box ref={onGapRef} sx={{ height: `${tailGap}px`, width: '100%' }} />
      )}
    </>
  );
};
